import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Form, Row } from "react-bootstrap";
import { useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";
import { FaPen, FaSave, FaTrash } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import FuncaoApiService from "../../services/api/FuncaoApiService";
import UtilService from "../../services/util";
import SelectFuncaoModal from "./SelectFuncaoModal";

const FuncaoDetailModal = ({ currentTab, item, edit, onCancel, dadosPlanejamento, setDadosPlanejamento, allFuncoes }) => {

    const [funcoesList, setFuncoesList] = useState([]);
    const [formData, setFormData] = useState({ tipoFuncao: "", horas: { [currentTab]: "0,00" }, taxaCustoVenda: '0,00' })
    const [errors, setErrors] = useState({})
    const [showSelectModal, setShowSelectModal] = useState(false);
    const match = useRouteMatch();
    const { key } = match.params;
    const fetchFuncoesList = async () => {
        try {
            const response = await FuncaoApiService.getAll();
            setFuncoesList(response.data.data);
        } catch (error) {
            console.error("Error fetching funcoes list:", error);
        }
    };

    const mask = (value) => {
        value = value.replaceAll('.', '').replace(',', '').replace(/\D/g, '')
        const options = { minimumFractionDigits: 2 }
        const result = new Intl.NumberFormat('pt-BR', options).format(
            parseFloat(value) / 100
        )
        return result
    }

    const onChangeData = (event) => {
        switch (event.target.name) {
            case "tipoFuncao":
                const nomeFuncao = funcoesList.find(item => Number(item.cod) === Number(event.target.value))?.nome
                setFormData({ ...formData, [event.target.name]: event.target.value, nomeFuncao })
                break;
            case "taxaCustoVenda":
                const value = mask(event.target.value)
                setFormData({ ...formData, [event.target.name]: value })
                break;
            case "horas":
                const inputValue = mask(event.target.value)
                setFormData({ ...formData, horas: { ...formData.horas, [currentTab]: inputValue } })
                break;
            case "observacao" :
                setFormData({ ...formData, [event.target.name]: event.target.value })
                break;
            default:
                break;
        }
        setErrors({})
    };

    const handleFuncao = (data) => {
        if (item) {
            const taxaCustoVenda = parseFloat((data.taxaCustoVenda).replaceAll('.', '').replace(',', '.'));
            const horas = parseFloat(data.horas[currentTab].replaceAll('.', '').replace(',', '.'));
            const custoTotal = taxaCustoVenda * horas;
            const nomeFuncao = funcoesList.find(item => Number(item.cod) === Number(data.tipoFuncao))?.nome
            
            const valorFuncaoAntigo = parseFloat((item.custo_total_funcao));
            const valorTotalFuncaoAtual = parseFloat(dadosPlanejamento.meses[currentTab].total_previsto_funcao.soma_custo_total_funcao);
            const novoValorFuncao = custoTotal;

            const horasFuncaoAntigo = parseFloat((item.horas_funcao));
            const horasFuncaoAtual = parseFloat(dadosPlanejamento.meses[currentTab].total_previsto_funcao.soma_horas_funcao);
            const novoHorasFuncao = horas;

            const itemAtualizado = {
                custo_venda_funcao: data.taxaCustoVenda.replaceAll('.', '').replace(',', '.'),
                custo_total_funcao: (custoTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })).replaceAll('.', '').replace(',', '.'),
                codigo_funcao: data.tipoFuncao,
                horas_funcao: data.horas[currentTab].replaceAll('.', '').replace(',', '.'),
                observacao: data.observacao
            }

            const dadosPlanejamentoAtualizado = {
                ...dadosPlanejamento,
                meses: {
                    ...dadosPlanejamento.meses,
                    [currentTab]: {
                        ...dadosPlanejamento.meses[currentTab],
                        previstoFuncao: dadosPlanejamento.meses[currentTab].previstoFuncao.map(func => {
                            if (func.id && item.id) {
                                return func.id === item.id ? {
                                    ...func,
                                    ...itemAtualizado,
                                    nome_funcao: nomeFuncao
                                } : func;
                            }
                            if (!func.id && !item.id) {
                                return func.tempId === item.tempId ? {
                                    ...func,
                                    ...itemAtualizado,
                                    nome_funcao: nomeFuncao
                                } : func;
                            }
                            return func;
                        }),
                        total_previsto_funcao: {
                            soma_custo_total_funcao: valorTotalFuncaoAtual - valorFuncaoAntigo + novoValorFuncao,
                            soma_horas_funcao: horasFuncaoAtual - horasFuncaoAntigo + novoHorasFuncao
                        }
                    }
                }
            }
            setDadosPlanejamento(dadosPlanejamentoAtualizado);
        } else {
            setDadosPlanejamento((prevDadosPlanejamento) => {
                const novaFuncao = data;
                let proximoIndice = 1;
                let proximoId = 3000;
                let proximoTempId = 1;

                // Descobrir maior índice, id e tempId existentes
                Object.values(prevDadosPlanejamento.meses).forEach((mes) => {
                    mes.previstoFuncao.forEach((func) => {
                        const idx = parseInt(func.indice, 10);
                        const id = parseInt(func.id, 10);
                        const tempId = parseInt(func.tempId, 10);
                        if (idx >= proximoIndice) proximoIndice = idx + 1;
                        if (id >= proximoId) proximoId = id + 1;
                        if (tempId >= proximoTempId) proximoTempId = tempId + 1;
                    });
                });

                const novosMeses = { ...prevDadosPlanejamento.meses };

                Object.entries(novaFuncao.horas).forEach(([mesAno, horasStr]) => {
                    const horas = parseFloat(horasStr.replace(",", "."));
                    const custoVenda = parseFloat(novaFuncao.taxaCustoVenda.replaceAll(".", "").replace(",", "."));
                    const custoTotal = parseFloat((horas * custoVenda));
                    
                    if (!novosMeses[mesAno]) {
                        novosMeses[mesAno] = {
                            total_previsto_funcao: {
                                soma_custo_total_funcao: 0,
                                soma_horas_funcao: 0
                            },
                            total_previsto_indireto: null,
                            previstoFuncao: [],
                            previstoIndireto: [],
                            valorVenda: "0.00"
                        };
                    }

                    novosMeses[mesAno].previstoFuncao.push({
                        tempId: String(proximoTempId++),
                        nome_funcao: novaFuncao.nomeFuncao,
                        custo_venda_funcao: custoVenda.toFixed(2),
                        custo_total_funcao: custoTotal.toFixed(2),
                        indice: String(proximoIndice++),
                        horas_funcao: horas.toFixed(2),
                        projeto: key,
                        codigo_funcao: novaFuncao.tipoFuncao,
                        mes_ano: mesAno,
                        observacao: novaFuncao.observacao
                    });

                    novosMeses[mesAno].total_previsto_funcao.soma_custo_total_funcao = novosMeses[mesAno]?.total_previsto_funcao?.soma_custo_total_funcao + custoTotal;
                    novosMeses[mesAno].total_previsto_funcao.soma_horas_funcao += horas;
                });

                return {
                    ...prevDadosPlanejamento,
                    meses: novosMeses,
                };
            });
        }
        onCancel();
    };

    const handleDeleteFuncao = (item) => {
        const updatedDeletedFuncao = dadosPlanejamento.meses[currentTab].previstoFuncao.filter(func => {
            if (item.id) {
                return func.id !== item.id;
            } else {
                return func.tempId !== item.tempId;
            }
        });

        setDadosPlanejamento((prevDadosPlanejamento) => {
            return {
                ...prevDadosPlanejamento,
                meses: {
                    ...prevDadosPlanejamento.meses,
                    [currentTab]: {
                        ...prevDadosPlanejamento.meses[currentTab],
                        previstoFuncao: updatedDeletedFuncao,
                        total_previsto_funcao: {
                            soma_custo_total_funcao: prevDadosPlanejamento.meses[currentTab].total_previsto_funcao.soma_custo_total_funcao - parseFloat(item.custo_total_funcao),
                            soma_horas_funcao: prevDadosPlanejamento.meses[currentTab].total_previsto_funcao.soma_horas_funcao - parseFloat(item.horas_funcao)
                        }
                    }
                }
            };
        })
        onCancel();
    }

    const handleSave = () => {
        const newErrors = {}

        if (!formData.tipoFuncao) newErrors.tipoFuncao = "Campo obrigatório"

        if (!formData.horas[currentTab] || formData.horas[currentTab] === "0,00") {
            newErrors.horas = "Campo obrigatório"
        }

        if (formData.taxaCustoVenda === "0,00") newErrors.taxaCustoVenda = "Campo obrigatório"

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors)
            return;
        }

        handleFuncao(formData);
    }

    const handleSelectFuncao = (funcao) => {
        setFormData({
            ...formData,
            tipoFuncao: funcao.codigo_funcao,
            horas: { ...formData.horas, [currentTab]: funcao.horas_funcao.replace(".", ",") },
            taxaCustoVenda: parseFloat(funcao.custo_venda_funcao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            nomeFuncao: funcao.nome_funcao,
            observacao: funcao.observacao
        });
        setShowSelectModal(false);
    };

    useEffect(() => {
        fetchFuncoesList();
    }, [edit]);

    useEffect(() => {
        if (item) {
            setFormData({
                ...formData,
                tipoFuncao: item.codigo_funcao,
                horas: { ...formData.horas, [currentTab]: item.horas_funcao.replace(".", ",") },
                taxaCustoVenda: parseFloat(item.custo_venda_funcao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                observacao: item.observacao
            })
        } else {
            setFormData({ ...formData, tipoFuncao: "", horas: { [currentTab]: "0,00" }, taxaCustoVenda: '0,00', observacaoFuncao: "" })
        }
    }, [item])

    return (
        <Form>
            <Row>
                <Col>
                    <Form.Label>Tipo</Form.Label>
                    <Form.Control
                        as="select"
                        name="tipoFuncao"
                        value={formData.tipoFuncao}
                        onChange={onChangeData}
                        disabled={!edit}
                        isInvalid={!!errors?.tipoFuncao}
                    >
                        <option value="">...</option>
                        {funcoesList
                            .sort((a, b) => UtilService.sortArrCallback(a, b, 'nome'))
                            .map((funcao) => (
                                <option key={funcao.cod} value={funcao.cod}>
                                    {funcao.cbo} - {funcao.nome}
                                </option>
                            ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                        {errors?.tipoFuncao}
                    </Form.Control.Feedback>
                </Col>
                <Col>
                    <Form.Label>Horas</Form.Label>
                    <Form.Control
                        type="text"
                        name="horas"
                        value={formData.horas[currentTab]}
                        onChange={onChangeData}
                        disabled={!edit}
                        isInvalid={!!errors?.horas}
                        maxLength={6}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.horas}
                    </Form.Control.Feedback>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col>
                    <Form.Label>Taxa de custo da venda</Form.Label>
                    <Form.Control
                        type="text"
                        name="taxaCustoVenda"
                        value={formData.taxaCustoVenda}
                        onChange={onChangeData}
                        disabled={!edit}
                        isInvalid={!!errors?.taxaCustoVenda}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.taxaCustoVenda}
                    </Form.Control.Feedback>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col>
                <Form.Label>Observações</Form.Label>
                <Form.Control
                    as="textarea"
                    name="observacao"
                    value={formData.observacao}
                    onChange={onChangeData}
                    disabled={!edit}
                    isInvalid={!!errors?.observacao}
                    maxLength={200}
                />
                <Form.Text muted className="text-end d-block">
                    {formData.observacao?.length || 0}/200
                </Form.Text>
                </Col>
            </Row>
            {edit &&
                <div className={`mt-3 d-flex justify-content-${item ? "end" : "between"}`}>
                    {!item && <Button 
                        variant="outline-info" 
                        style={{ marginRight: "10px", cursor: allFuncoes.length === 0 ? "not-allowed" : "pointer" }} 
                        disabled={allFuncoes.length === 0} 
                        onClick={() => setShowSelectModal(true)}
                    >
                        Adicionar um de outro mês
                    </Button>}
                    <ButtonGroup>
                        <Button
                            variant={"outline-info"}
                            onClick={handleSave}
                            disabled={!edit}
                        >
                           <><FaPen /> Confirmar</>

                        </Button>
                        <Button
                            variant="outline-danger"
                            onClick={item ? () => handleDeleteFuncao(item) : onCancel}
                            disabled={!edit}
                        >
                            {item ? <><FaTrash /> Excluir</> : <><MdClose /> Cancelar</>}
                        </Button>
                    </ButtonGroup>
                </div>}
            
            <SelectFuncaoModal
                show={showSelectModal}
                onHide={() => setShowSelectModal(false)}
                funcoes={allFuncoes}
                onSelect={handleSelectFuncao}
            />
        </Form>
    )
};

export default FuncaoDetailModal;
